var syncing = false;
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = window.mrk_money_format;
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// product page logic start here

function buildRequestUrl() {
  const _this = $('frame-variant-picker');
  if ($(_this).length == 0) { return }
  const selectedOption = $('frame-variant-picker input:checked'); // Get the checked input
  const optionValueId = selectedOption.data('option-value-id'); // Get its data-option-value-id

  if (!optionValueId) {
    return; // If no option value ID is found, return nothing
  }

  const productUrl = $(_this).data('product-url');

  // Resolve the section id. On the PDP it comes from the .shopify-section
  // ancestor and is the FULL id (e.g. "template--123__main"). Inside the
  // quick-add modal there is no such ancestor, so quick-add.js captures the
  // real id from the fetched page into window.mrkQuickAddSectionId.
  // NOTE: the bare key "main" 404s for this param - only the full id works -
  // so when we can't resolve a full id we omit section_id entirely and let the
  // full ?view=frame page render (still returns the frame picker).
  const $section = $(_this).parents('.shopify-section');
  var section_id = '';
  if ($section.length && $section.attr('id')) {
    section_id = $section.attr('id').replace('shopify-section-', '');
  } else if (window.mrkQuickAddSectionId) {
    // Quick-add modal: use the full section id captured from the fetched page so
    // the frame picker re-renders through the SAME ?view=frame path as the PDP.
    // (It previously used ?view=quick-view, which resolves the MAIN product from
    // a FRAME option-value id - a mismatch - so the picker never updated on a
    // size change. option_values here is a frame-product option value, so it
    // only makes sense in the frame view.)
    section_id = window.mrkQuickAddSectionId;
  }

  if (section_id) {
    return `${productUrl}?section_id=${section_id}&option_values=${optionValueId}&view=frame`;
  }
  return `${productUrl}?option_values=${optionValueId}&view=frame`;
}
function updatePrices(prices) {
  var final_price = 0;
  var final_Compare_at_price = 0;
  prices.map(p => {
    final_price = final_price + p.price;
    final_Compare_at_price = final_Compare_at_price + p.compare_price;
  });
  var discount = (final_Compare_at_price - final_price) * 100 / final_Compare_at_price;
  $('.mrk-discount-percent').html(discount.toFixed(0));
  $('.mrk-main-price').html(Shopify.formatMoney(final_price));
  $('.mrk-main-compare-price').html(Shopify.formatMoney(final_Compare_at_price));
  if (discount > 0) {
    $('.mrk-sale-badge-wrapper').show();
    $('.mrk-main-compare-price').show();
  } else {
    $('.mrk-sale-badge-wrapper').hide();
    $('.mrk-main-compare-price').hide();
  }
}
function RemoveUnavailableVariants() {
  if (window.availableFrameIDs && window.availableFrameIDs.length) {
    const $childFrames = $('.mrk-child-frame-item');
    // window.availableFrameIDs is a PAGE global, built from the CURRENT product's
    // custom.child_frames metafield (snippets/mrk-global-veriables.liquid). Inside the quick-add
    // modal it can still hold the HOST product's ids - so for a print whose frame product differs
    // (e.g. a `frame-1` print opened from a `classic-frame` page) NOTHING matches and the loop
    // below deleted every colour swatch, leaving only the separately-rendered "Unframed" one.
    // Removing all of them is never a valid outcome, so treat "no match at all" as "this list
    // isn't for this picker" and leave the swatches untouched. When the list DOES belong to this
    // picker, filtering below is unchanged.
    let anyMatch = false;
    $childFrames.each(function () {
      if (window.availableFrameIDs.includes(Number($(this).attr('variant-id')))) anyMatch = true;
    });
    if (!anyMatch) return;
    $childFrames.each(function () {
      const variantId = Number($(this).attr('variant-id'));
      if (!window.availableFrameIDs.includes(variantId)) {
        $(this).remove();
      }
    });
    // NOTE: arrow visibility is NOT decided here anymore. The old ">3 child
    // frames" count set an inline display on the arrows container, which fought
    // (and beat) the real-overflow logic in refreshSwatchOverflow - e.g. 3
    // frames + the "Unframed" swatch = 4 items that overflow and DO need arrows,
    // yet the count said "hide". refreshSwatchOverflow is now the single source
    // of truth, driven by actual overflow.
  }

}
function getMainParentVariant(main_variant) {
  // Some products (e.g. simple/framed-print-only variants surfaced in the
  // quick-add modal) have no checked frame switcher, so .val() is undefined.
  // Bail out to the variant we were given rather than crashing on .toLowerCase().
  var checked_frame = $('.mrk-frame-switcher input:checked').val();
  if (!checked_frame) return main_variant;
  var frame_swatch = $(`variant-picker [frame-color="${checked_frame.toLowerCase()}"]`).val();
  var parent = (window.main_product_data || []).find(v =>
    v.option1 === main_variant.option1 &&
    v.option2 === frame_swatch
  );
  // Never return undefined - callers assign this back to main_variant and then
  // read main_variant.price/.id.
  return parent || main_variant;
}
// Framing system selection - parent-only ("framed_print_only") vs parent+child ("child_frame").
// Resolution priority: variant metafield override -> product size list -> derived from child_frames.
function getFramingMode(main_variant) {
  if (!main_variant || main_variant.id == null) return 'Child frame';

  var vid = String(main_variant.id);
  var fpoVariantIds = (window.framed_print_only_variant_ids || []).map(String);
  var cfVariantIds = (window.child_frame_variant_ids || []).map(String);
  if (fpoVariantIds.indexOf(vid) > -1) return 'Framed print only';
  if (cfVariantIds.indexOf(vid) > -1) return 'Child frame';
  // If the merchant has explicitly marked some variants as "Child frame",
  // treat the marked list as an allowlist - any variant outside it is parent-only.
  if (cfVariantIds.length > 0) return 'Framed print only';

  var size = String(main_variant.option1 || '').trim().toLowerCase();
  var norm = function (s) { return String(s).trim().toLowerCase(); };
  var fpoSizes = (window.framed_print_only_sizes || []).map(norm);
  var childSizes = (window.child_frame_sizes || []).map(norm);

  if (fpoSizes.indexOf(size) > -1) return 'Framed print only';
  // Implicit fallback: if the product declares which sizes have child frames
  // and the selected size is not in that set, treat it as framed-print-only.
  if (childSizes.length && childSizes.indexOf(size) === -1) return 'Framed print only';
  // Derived fallback: the frame product itself knows which sizes it can frame.
  // Its hidden Size fieldset (frame-variant-picker, present in the initial
  // render AND every ?view=frame refetch) carries data-option-available per
  // size. When the selected size's frame option value is unavailable (e.g. A0:
  // all child frames out of stock), variant-main-picker-frame.liquid skips
  // every colour swatch server-side and the child-frame picker renders empty -
  // the size is only sellable through the artwork's own "Framed ..." variants,
  // so it must be FPO. Matched by exact value (size values contain quotes,
  // e.g. 33x47" (A0), so an attribute selector can't be used); sizes missing
  // from the frame product keep the legacy behaviour below.
  var $frameSize = $('frame-variant-picker input[type=radio]').filter(function () {
    return norm($(this).val()) === size;
  }).first();
  if ($frameSize.length && $frameSize.attr('data-option-available') === 'false') {
    return 'Framed print only';
  }
  return 'Child frame';
}
function updateVariants() {
  var main_variant = JSON.parse($('#mrk-main-variant-data').text() || '{}');
  // No canonical #mrk-main-variant-data in the DOM (e.g. every picker arm hidden
  // mid-transition): acting on {} would blank items[0][id] (jQuery .val(undefined)
  // sets '') and overwrite the real prices with formatMoney(NaN) → £0. Keep the
  // last good form/price state and let the next run with real data resync.
  if (main_variant == null || main_variant.id == null) return;
  var child_frame = $('[name="framing-service"]').is(':checked'),
    fulfillment_function = $('.mrk-fullfilment-sku').length,
    free_framing_service_data = JSON.parse($('#mrk-framing-service-data').text() || '{}'),
    free_framing_service = free_framing_service_data.free_framing_service || window.free_framing_service,
    frame = $('.mrk-frame-switcher input:checked'),
    frame_price = $(frame).data('variantPrice'),
    frame_compare_price = $(frame).data('variantComparePrice'),
    framing_service = !$('[name="framing-service"]').is(':checked'),
    framing_service_variant = $('[name="framing-service"]').val(),
    framing_service_compare_price = $('[name="framing-service"]').data('comparePrice'),
    framing_service_price = $('[name="framing-service"]').data('price'),
    frame_variant = $(frame).data('variantId'),
    frame_id = $('media-gallery .mrk-active-gallery-frame').data('frameId'),
    is_unframed = frame_variant ? false : true,
    variant_title = main_variant.title || '',
    size = (variant_title.match(/\(([^)]+)\)/) || [])[1] || '',
    mrk_sku = '',
    variants = [],
    prices = [];
  var framing_mode = getFramingMode(main_variant);
  var force_fpo = framing_mode === 'Framed print only';
  // Products with NO framing metafields at all (typically non-A-ratio artworks:
  // no child_frames, no framed_print_only_sizes, no framing_sale_mode) fall
  // through getFramingMode to 'Child frame' - yet their framed variants ARE
  // framed-print-only: option2 is "Framed black"/"Framed natural"/... with the
  // frame included in the variant price, and there is no frame-variant-picker
  // on the page. Same rule as the live theme: a selected option2 beginning
  // with "framed" forces FPO, so the framing-service / free-framing message
  // shows for these products too.
  if (!force_fpo && String(main_variant.option2 || '').trim().toLowerCase().indexOf('framed') === 0) {
    force_fpo = true;
  }
  // "Child frame" mode is fully legacy: pricing, cart line, and the unframed-
  // parent vs. framed-parent decision are all driven by the framing-service
  // checkbox below. No force_cf override - keep the original child/parent
  // system intact for those variants.
  // On a mode FLIP the visible frame slider swaps (child picker <-> the main
  // picker's FPO swatches). The revealed one was display:none whenever overflow
  // was last measured - refreshSwatchOverflow skips hidden sliders - so its
  // .mrk-enable-controls (the arrows' CSS gate, mrk.css) was never applied and
  // the arrows stay hidden (e.g. size change into A0/FPO). Re-bind + re-measure
  // AFTER the class toggle, same order the bootstrap enforces on page load.
  var fpo_mode_flipped = $('body').hasClass('mrk-fpo-active') !== force_fpo;
  $('body').toggleClass('mrk-fpo-active', force_fpo);
  if (fpo_mode_flipped) {
    initSwatchSlider();
  }
  if (force_fpo) {
    // Framed-Print-Only: artwork variant already includes the frame.
    // No child frame item, no framing service line; submit only the parent variant.
    if (frame_id) {
      $('.mrk-frame-id').val(frame_id).prop('disabled', false);
    } else {
      $('.mrk-frame-id').prop('disabled', true);
    }
    $('.mrk-framing-service-wrapper:not(.bundle)').hide();
    // FPO framed variants already include the frame + framing in the price.
    // Mirror the cart rule (frame-framing-service.liquid): a framed option2
    // selected => show the "free framing" message; unframed selected => hide.
    // The included_free_framing_service metafield still forces it on when set.
    var fpo_framed_selected = String(main_variant.option2 || '').trim().toLowerCase().indexOf('framed') === 0;
    if (free_framing_service || fpo_framed_selected) {
      $('.free-framing-service:not(.bundle)').show();
    } else {
      $('.free-framing-service:not(.bundle)').hide();
    }
  } else if (!is_unframed) {
    if (fulfillment_function || (!fulfillment_function && child_frame)) {
      variants.push({ id: frame_variant, parent_id: main_variant.id });
      prices.push({ price: frame_price, compare_price: frame_compare_price });
      mrk_sku = size + '-' + ($('.mrk-frame-switcher input:checked').val() || '').toString().toUpperCase() + '-FRAME';
    } else {
      var mrk_variant = getMainParentVariant(main_variant)
      main_variant = mrk_variant;
    }
    if (framing_service) {
      if (!free_framing_service) {
        variants.push({ id: framing_service_variant, parent_id: main_variant.id });
        prices.push({ price: framing_service_price, compare_price: framing_service_compare_price });
      }
      mrk_sku = size + '-FRAMED-' + ($('.mrk-frame-switcher input:checked').val() || '').toString().toUpperCase();
    }

    $('.mrk-frame-id').val(frame_id).prop('disabled', false);
    $('.mrk-framing-service-wrapper:not(.bundle)').show();
    if (free_framing_service) {
      $('.mrk-framing-service-wrapper:not(.bundle)').hide();
      $('.free-framing-service:not(.bundle)').show();
    } else {
      $('.free-framing-service:not(.bundle)').hide();
      $('.mrk-framing-service-wrapper:not(.bundle)').show();
    }
  } else {
    var mrk_variant = getMainParentVariant(main_variant)
    main_variant = mrk_variant;
    $('.free-framing-service:not(.bundle)').hide();
    $('.mrk-framing-service-wrapper:not(.bundle)').hide();
    $('.mrk-frame-id').prop('disabled', true);
  }

  prices.push({ price: main_variant.price, compare_price: main_variant.compare_at_price || main_variant.price });

  updatePrices(prices);
  $('.mrk-product-form-wrapper [name="items[0][id]"]').val(main_variant.id);
  $('.mrk-fullfilment-sku').val(mrk_sku);
  // Horizon's product-form disables the add-to-cart button on every variant
  // change and only re-enables it via its own section fetch. Inside the
  // quick-add modal that re-enable is unreliable, leaving the button stuck
  // disabled after a size change. Since we've just resolved a purchasable
  // variant here, restore the button to its normal (enabled) state. No-op on
  // the PDP (already enabled); unavailable variants are left disabled.
  if (main_variant && main_variant.available !== false) {
    $('.mrk-product-form-wrapper [ref="addToCartButton"]').prop('disabled', false).removeAttr('disabled');
  }
  var inputs = '';
  variants.forEach(function (v, i) {
    var idx = i + 1;
    inputs += '<input name="items[' + idx + '][id]" type="hidden" value="' + (v.id || '') + '" />\n';
    inputs += '<input name="items[' + idx + '][parent_id]" type="hidden" value="' + (v.parent_id || '') + '" />\n';
  });

  $('.mrk-hidden-inputs').empty().append(inputs);
  if (!force_fpo && !fulfillment_function && child_frame) {
    $('.mrk-hidden-inputs').append('<input name="items[0][properties[_main_variant]]" type="hidden" value="' + (getMainParentVariant(main_variant).id || '') + '" />')
  }
  var frame_color_value = force_fpo ? (main_variant.option2 || '') : $(frame).val();
  $('.mrk-frame-color').val(frame_color_value).prop('disabled', false);
  $('.mrk-bundle-id').val(Math.floor((Date.now() % 100000) * Math.random())).prop('disabled', false);
}
function alreadyCheckedFrame() {
  $(`.mrk-frame-switcher input[frame-color="${window.selected_frame}"]`).prop('checked', true).trigger('change');
  setTimeout(function () {
    if ($('.mrk-frame-switcher input:checked').attr('frame-color') != window.selected_frame) {
      $(`.mrk-frame-switcher input[frame-color="${window.selected_frame}"]`).prop('checked', true).trigger('change');
    }
    if($(`.mrk-frame-switcher input[frame-color="${window.selected_frame}"]`).length == 0){
      $(`.mrk-frame-switcher input[frame-color]`).prop('checked', true).trigger('change');
    }
  }, 100)
}
function initStickyAddToCart() {
  var $FormWrapper = $('.product-details product-form-component:not(.mrk-bundle-form)');
  if ($FormWrapper.length) {
    var lastScrollTop = 0;
    var originalHeight = $FormWrapper.outerHeight();
    $FormWrapper.css('--height', originalHeight + 'px');
    $(window).on('scroll', function () {
      // Hidden form (e.g. bundle pack mode hides the native buy-box): offset() reads 0,
      // so any scroll past 100px would pin the fixed class to the hidden form — and it
      // stayed applied when switching back to single view, breaking the CTA position.
      // Not visible → strip the sticky state and bail.
      if (!$FormWrapper.is(':visible')) {
        $FormWrapper.removeClass('mrk-fixed-add-to-cart-form');
        $FormWrapper.css('min-height', '');
        return;
      }
      var originalOffsetTop = $FormWrapper.offset().top + 100;
      var scrollTop = $(this).scrollTop();
      // Always add class when top bar has scrolled up past original position
      if (scrollTop > originalOffsetTop) {
        if (!$FormWrapper.hasClass('mrk-fixed-add-to-cart-form')) {
          $FormWrapper.addClass('mrk-fixed-add-to-cart-form');
        }
      } else {
        $FormWrapper.removeClass('mrk-fixed-add-to-cart-form');
        $FormWrapper.css('min-height', '');
      }

      // If user scrolls up while fixed, set min-height
      if (scrollTop < lastScrollTop && scrollTop > originalOffsetTop) {
        $FormWrapper.css('min-height', originalHeight + 'px');
      }

      lastScrollTop = scrollTop;
    });
  }
}
var SWATCH_TOLERANCE = 2; // px, absorbs sub-pixel rounding

// Decide whether each slider NEEDS arrows at all (does its content overflow?).
// This is the only place .mrk-enable-controls (the container's CSS gate) is
// toggled - and it runs on init / resize / image-load, NOT on scroll - so a
// transient mis-measurement while scrolling can never collapse the arrows.
// Hidden sliders (display:none) are skipped so their state isn't clobbered.
function refreshSwatchOverflow() {
  $('.mrk-swatches-slider-wrapper').each(function () {
    var el = $(this).find('.mrk-swatches-wrapper')[0];
    if (!el || (el.offsetParent === null && el.getClientRects().length === 0)) return;
    var overflows = (el.scrollWidth - el.clientWidth) > SWATCH_TOLERANCE;
    $(this).toggleClass('mrk-enable-controls', overflows);
  });
  updateSwatchArrows();
}

// Show/hide the individual prev/next buttons by scroll position. Only touches
// sliders already marked scrollable (.mrk-enable-controls) and never changes
// that class - so scrolling can't make the whole arrow set disappear.
function updateSwatchArrows() {
  $('.mrk-swatches-slider-wrapper.mrk-enable-controls').each(function () {
    var $slider = $(this);
    var el = $slider.find('.mrk-swatches-wrapper')[0];
    if (!el) return;

    var maxScroll = el.scrollWidth - el.clientWidth;
    var scrollLeft = el.scrollLeft;

    $slider.find('.slideshow-control[ref="previous"]').toggle(scrollLeft > SWATCH_TOLERANCE);
    $slider.find('.slideshow-control[ref="next"]').toggle(scrollLeft < maxScroll - SWATCH_TOLERANCE);
  });
}

function initSwatchSlider() {
  var $wrappers = $('.mrk-swatches-wrapper');
  if ($wrappers.length === 0) return;

  // scroll doesn't bubble, so bind it directly on each wrapper (re-applied on
  // every render). Scroll only moves the prev/next buttons, never the container.
  $wrappers.off('scroll.swatchSlider').on('scroll.swatchSlider', updateSwatchArrows);
  // Overflow can change on resize and, crucially, when the lazy-loaded swatch
  // images finish loading (their width is what makes the row overflow) - both
  // recompute whether arrows are needed.
  $(window).off('resize.swatchSlider').on('resize.swatchSlider', refreshSwatchOverflow);
  $wrappers.find('img').off('load.swatchSlider').on('load.swatchSlider', refreshSwatchOverflow);

  // Initial pass + deferred passes: 350ms for the modal open animation, 1200ms
  // as a backstop for slow image loads so the arrows aren't left hidden.
  refreshSwatchOverflow();
  setTimeout(refreshSwatchOverflow, 350);
  setTimeout(refreshSwatchOverflow, 1200);
}
function updateProductPageFrame() {
  if ($('variant-picker').length == 0) {
    return
  }
  // In FPO mode the frame-variant-picker is hidden and its :checked:eq(1) is
  // stale (typically the last/default frame, e.g. oak). Drive the gallery
  // image from the main variant-picker's frame swatch instead. Detect the
  // mode from the current main variant so we pick up size-driven transitions
  // even before body class catches up.
  var current_main_variant = {};
  try { current_main_variant = JSON.parse($('#mrk-main-variant-data').text() || '{}'); } catch (e) {}
  var is_fpo_now = typeof getFramingMode === 'function' && getFramingMode(current_main_variant) === 'Framed print only';
  var frameName;
  if (is_fpo_now) {
    var $vpFrame = $('variant-picker input:checked').filter(function () {
      var fc = ($(this).attr('frame-color') || '').trim();
      return fc.length > 0;
    }).last();
    frameName = ($vpFrame.attr('frame-color') || '').toLowerCase();
  } else {
    var selectedFrame = $('frame-variant-picker input:checked:eq(1)');
    frameName = $(selectedFrame).val()?.toLowerCase();
  }
  // Fallback (live-theme parity): products without a frame-variant-picker and
  // without frame-color attributes resolve nothing above, but their main
  // variant's option2 ("Framed black") names the frame - derive it from there
  // so the gallery frame overlay and _frame_id follow the selection.
  if (!frameName || frameName === 'unframed') {
    try {
      var fallback_variant = JSON.parse($('#mrk-main-variant-data').text() || '{}');
      var fallback_o2 = String(fallback_variant.option2 || '').trim().toLowerCase();
      if (fallback_o2.indexOf('framed') === 0) {
        frameName = fallback_o2.replace(/^framed[\s-]*/, '').replace(/\s+/g, '-');
      }
    } catch (e) {}
  }
  // Default-preview fallback: with an unframed default (show_default_black_variant)
  // and no real shopper frame pick yet, resolve to the default preview frame
  // instead of stripping the overlay. Every reassert path (both fetch callbacks
  // on a size change, mrkVariantChanged, drool-frame-default.js) funnels through
  // here, so resolving "unframed" would end first loads with no frame at all.
  if ((!frameName || frameName === 'unframed') && window.show_default_black_variant && !window.__mrkFrameTouched) {
    frameName = String(window.mrk_default_preview_frame || 'black');
  }
  $('media-gallery .mrk-featured-product-frame-wrapper .mrk-frame-image-item').removeClass('mrk-active-gallery-frame').hide();
  $(`media-gallery .mrk-frame-image-item[color="${frameName}"]`).addClass('mrk-active-gallery-frame').show();
  $(`.mrk-tab-trigger[data-content="${frameName}"]`).click();
  updateVariants();
}
function mrkApplyGiftAdjustments() {
  var el = document.getElementById('mrk-gift-json');
  if (!el) return;

  var items;
  try { items = JSON.parse(el.textContent || '[]'); } catch (e) { return; }
  if (!Array.isArray(items) || !items.length) return;

  // Only process items where new_qty is explicitly 0 (removal of free gifts)
  var itemsToRemove = items.filter(function(it) {
    return parseInt(it.new_qty, 10) === 0;
  });

  if (!itemsToRemove.length) return;

  // Build updates object with ONLY the gift item keys set to 0
  var updates = {};
  itemsToRemove.forEach(function(it) {
    var key = String(it.key || '');
    if (!key) return;
    updates[key] = 0;
  });

  if (!Object.keys(updates).length) return;

  // Get section IDs for cart refresh
  const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
    .map(el => el.dataset.sectionId)
    .filter(Boolean);

  // Use /cart/update.js with specific keys — this only touches what you pass in
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    dataType: 'json',
    data: { updates: updates, sections: sectionIds }
  }).then(function(response) {
    if (typeof window.manualCartRefresh === 'function') {
      window.manualCartRefresh(response);
    }
  });
}
$(document).on('mrkBeforeVariantChanged', function (e) {
  var selectedOption = e.detail;
  $('.mrk-size-selector-wrapper details').prop('open', false);
  $('frame-variant-picker input').each(function () {
    if ($(this).val() === selectedOption) {
      $(this).prop('checked', true);
    }
  });
  if ($(`frame-variant-picker input[value='${selectedOption}']`).length == 0) {
    return;
  }
  window.selected_frame = $('.mrk-frame-switcher input:checked').attr('frame-color');
  var url = buildRequestUrl();
  $.get(url, function (response) {
    // Locate the picker in the response. $(response).find(...) only searches DESCENDANTS, so it
    // misses the picker whenever it comes back as a top-level node - the ?view=frame reply is a
    // full page on the PDP but a section fragment in the quick-add modal, and the two nest
    // differently. When it missed, `variantPickerHtml` was undefined and the .html() below BLANKED
    // the picker: its Black/White/Oak swatches vanished and only the print's own "Unframed" option
    // (which lives in a separate <variant-picker>) was left. $.parseHTML is used rather than
    // $('<div>').html() so scripts in the response are never executed - same as before.
    var $parsed = $($.parseHTML(response));
    var $picker = $parsed.filter('frame-variant-picker').add($parsed.find('frame-variant-picker'));
    var variantPickerHtml = $picker.first().html();
    // Only replace when we actually have markup. A failed/mismatched response now leaves the
    // current swatches in place instead of wiping them.
    if (variantPickerHtml) {
      $('frame-variant-picker').html(variantPickerHtml);
    }
    RemoveUnavailableVariants();
    initSwatchSlider();
    alreadyCheckedFrame();
  });
  if (window.selected_frame) {
    $(`.mrk-tab-trigger[data-content="${window.selected_frame}"]`).click();
  } else {
    $(`.mrk-tab-trigger`).first().click();
  }
});
;(function () {
  // Module-scoped previous-framing-mode tracker, closed over by the handler.
  // Seeded by the bootstrap below from the initial main variant.
  var mrkPrevFramingMode = null;
  window.__mrkSeedPrevFramingMode = function (mode) {
    if (mrkPrevFramingMode === null && mode) mrkPrevFramingMode = mode;
  };

  $(document).on('mrkVariantChanged', function (e) {
    // Snap to Unframed ONLY on a real FPO -> Child-frame transition AND only
    // for products that use the child-frame system (frame-variant-picker is
    // rendered). Pure CF products would otherwise snap on every change
    // (cascades to oak), and "normal" products with mixed framing_sale_mode
    // metafields would snap any non-FPO pick back to Unframed.
    var newVariant = (e && e.detail) || {};
    var newMode = (newVariant && newVariant.option1 != null && typeof getFramingMode === 'function')
      ? getFramingMode(newVariant)
      : null;
    var prevMode = mrkPrevFramingMode;
    // Update tracker BEFORE any early return so the snap's re-entrant
    // mrkVariantChanged sees prevMode === 'Child frame' and exits.
    if (newMode) mrkPrevFramingMode = newMode;

    if (newMode === 'Child frame' && prevMode === 'Framed print only' && $('frame-variant-picker').length > 0) {
      var unframedValue = String(window.mrk_unframed_value || 'Unframed').trim().toLowerCase();
      var currentOption2 = String(newVariant.option2 || '').trim().toLowerCase();
      if (currentOption2 && currentOption2 !== unframedValue) {
        var $unframedSwatch = $('variant-picker .variant-option--swatches input').filter(function () {
          return String($(this).val() || '').trim().toLowerCase() === unframedValue;
        }).first();
        if ($unframedSwatch.length && !$unframedSwatch.is(':checked')) {
          $unframedSwatch[0].dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }
    }

    alreadyCheckedFrame();
    // The main variant-picker was just morphed by variant-picker.js: the swatch
    // wrappers (and their scroll/image-load bindings) may have been replaced and
    // the server render doesn't carry the .mrk-enable-controls state. Re-bind
    // and re-measure so the frame arrows survive every size/frame change.
    initSwatchSlider();
    if (!$('.mrk-frame-switcher input').length) {
      // Pure framed-print-only product (no frame-variant-picker rendered): the
      // alreadyCheckedFrame cascade above has nothing to trigger, so nothing
      // would re-run updateVariants after this change. Drive the frame image,
      // framing-service visibility and cart inputs directly.
      if ($('variant-picker').length) {
        updateProductPageFrame();
      } else {
        var frame_id = $('media-gallery .mrk-active-gallery-frame').data('frameId');
        if (frame_id) $('.mrk-frame-id').val(frame_id).prop('disabled', false);
      }
    }
  });
})();
// Track a REAL shopper frame pick (trusted event only - programmatic cascades
// don't count). drool-frame-default.js checks this flag to stop re-asserting
// the default preview frame once the shopper has chosen one.
$(document).on('change', 'variant-picker input[frame-color], .mrk-frame-switcher input, [name="framing-service"]', function (e) {
  if (!(e.originalEvent && e.originalEvent.isTrusted)) return;
  // Size radios also carry an (empty) frame-color attr, so attribute presence is
  // not enough — only a non-empty frame-color (a real frame swatch) counts.
  if ($(this).is('variant-picker input') && !String($(this).attr('frame-color') || '').trim()) return;
  window.__mrkFrameTouched = true;
});
$(document).on('change', '.mrk-frame-switcher input', updateProductPageFrame);
$(document).on('change', '[name="framing-service"]', updateProductPageFrame);
$(document).on('click', '.mrk-swatches-slider-wrapper .slideshow-control', function () {
  var $slider = $(this).closest('.mrk-swatches-slider-wrapper');
  var $wrapper = $slider.find('.mrk-swatches-wrapper');
  if ($wrapper.length === 0) return;

  // Step by one swatch; measure the clicked slider's own swatch (falls back to
  // ~80% of the visible width if it hasn't laid out yet, e.g. in a just-opened modal).
  var swatchWidth = $slider.find('.variant-option__button-label--has-swatch').first().outerWidth(true);
  var step = (swatchWidth || Math.round($wrapper.outerWidth() * 0.8) || 100) + 5;
  var current = $wrapper.scrollLeft();
  var target = $(this).attr('ref') === 'previous' ? current - step : current + step;

  $wrapper.stop(true).animate({ scrollLeft: target }, 100, updateSwatchArrows);
});

function updateFrame(){
  if ($('[name="mrk-collection-frame"]:checked').length) {
    var selected_frame = $('[name="mrk-collection-frame"]:checked').val().toLowerCase();
    $('.mrk-frame-image-item').hide();
    $('.mrk-collection-item-frames-wrapper').removeClass('mrk-collection-frame-item-active');
    $(`.mrk-frame-wrapper`).each(function () {
      if ($(this).find(`.mrk-frame-image-item[color="${selected_frame}"]`).length) {
        $(this).find(`.mrk-frame-image-item[color="${selected_frame}"]`).show();
        $(this).parents('.mrk-collection-item-frames-wrapper').addClass('mrk-collection-frame-item-active');
        // var url_item = $(this).parents('.boost-sd__product-link');
        // var url = $(url_item).attr('data-href') || $(url_item).attr('href');
        // var final_url = url + '?frame=' + selected_frame;
        // $(url_item).attr('href', final_url).attr('data-href', url)
      }
    })
  }
}
$(document).on('change', '[name="mrk-collection-frame"]', updateFrame);
$(document).on('click', '.mrk-detail-option-item', function (e) {
  e.preventDefault();
  e.stopPropagation();

  var $item = $(this);
  var $details = $item.closest('details');
  var $container = $item.closest('form') || $item.closest('details');
  var $target = $details.find('.mrk-selected-detail-value').first();
  var content = $item.find('.upsell-dropdown-option').first().html() || $item.find('.addon-dropdown-option').first().html();

  if (!content || !$target.length) return;

  // Replace the selected area's content with the clicked option's content
  $target.html(content);

  // Close the <details>
  $details.prop('open', false);

  var variant = $(this).attr('value') || '',
    color = $(this).attr('color') || '',
    frame_id = $(this).attr('frame_id') || '',
    main_variant = $(this).attr('main-variant') || '';
  var $input = $container.find('[name="items[1][id]"]');
  if (variant === '') {
    $input.prop('disabled', true).val('');
    $container.find('.upsell-parent-id').prop('disabled', true);
    $container.find('.mrk-cart-frame-add').prop('disabled', true);
  } else {
    $input.prop('disabled', false).val(variant).attr('color', color).attr('main-variant', main_variant).attr('frame_id', frame_id);
    $container.find('.upsell-parent-id').prop('disabled', false);
    $container.find('.mrk-cart-frame-add').prop('disabled', false);
    $container.find('.mrk-upsell-frame-color').prop('disabled', false).val(color);
  }
});
$(document).on('click', function (e) {
  const $details = $('.mrk-custom-detail[open]');
  if ($details.length && !$(e.target).closest('.mrk-custom-detail').length) {
    $details.prop('open', false);
  }
});
$(document).on('click', '.mrk-cart-upsell-form .mrk-custom-detail summary', function () {
  const details = $(this).parents('details');

  setTimeout(() => {
    if (details.prop('open')) {
      const dropdown = details.find('.mrk-upsell-option-dropdown')[0];
      if (dropdown) {
        dropdown.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }
  }, 50);
});

$(document).on('click', '.mrk-tab-trigger', function () {
  const frame = $(this).data('content');
  $('.mrk-tab-trigger').removeClass('tab-active');
  $(this).addClass('tab-active');
  $('.mrk-tab-content-item').hide();
  $(`.mrk-tab-content-item[frame="${frame}"]`).show();
});
$(document).on('click', '.mrk-tab-item-btn', function () {
  const section = $(this).parents('.shopify-section'),
    tab = $(this).data('tab');
  const html = $(this).next('template').html(),
    image = $(html).find('img'), srcset = $(image).data('srcset'), src = $(image).data('src');
  if (image != undefined) {
    $(section).find('.main-tab-image')
      .attr({ 'data-srcset': srcset, 'data-src': src })
      .removeAttr('src srcset')
      .removeClass('lazyloaded ls-is-cached')
      .addClass('lazyload');
  }
  $(section).find('.mrk-tab-item-btn').removeClass('mrk-tab-active');
  $(this).addClass('mrk-tab-active');
  $(section).find('.mrk-tab-content').hide();
  $(`.mrk-tab-content[data-tab="${tab}"]`).show();

});
$(document).on('click', '.mrk-cart-frame-add', function (e) {
  e.preventDefault();
  var $w = $(this).closest('.mrk-cart-frame-upsell');
  var childId = Number($w.find('.mrk-frame-cart-addon-id').val());
  var color = $w.find('.mrk-frame-cart-addon-id').attr('color');
  var parentId = Number($w.find('.mrk-frame-cart-addon-id').attr('parentVariant'));
  var frame_id = Number($w.find('.mrk-frame-cart-addon-id').attr('frame_id'));
  var main_variant = $w.find('.mrk-frame-cart-addon-id').attr('main-variant');
  var add_parent = $w.find('.mrk-frame-cart-addon-id').attr('addparent') == 'true';
  if (!parentId || !childId) return alert('Select main & sub variants');
  const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);

  // 1️⃣ Remove parent variant first
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: { id: parentId, quantity: 0 },
    dataType: 'json'
  }).always(function () {
    // 2️⃣ Build items array based on whether main-variant exists
    var items;
    if (add_parent) {
      items = [
        { id: parentId, quantity: 1, properties: { 'Color': color, '_main_variant': Number(main_variant), '_frame_id': frame_id } },
        { id: childId, quantity: 1, parent_id: parentId }
      ];
    } else {
      items = [
        { id: childId, quantity: 1, properties: { 'Color': color } }
      ];
    }

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: { items: items, sections: sectionIds }
    }).then(function (response) {
      window.manualCartRefresh(response);
    });
  });
});
$(document).on('click', '[href="#open-cart"]', function (e) {
  e.preventDefault();
  $('.mrk-cart-icon-button').trigger('click');
})
$(document).on('click', '.mrk-cart-framing-add', function (e) {
  e.preventDefault();

  const $btn = $(this);
  let parentId = Number($btn.attr('parent')) || 0;
  let childId = Number($btn.attr('frame')) || 0;
  if (Number($btn.attr('main_variant'))) {
    parentId = Number($btn.attr('main_variant'));
    childId = null;
  }
  const quantity = Number($btn.attr('quantity')) || 1;
  const framingServiceId = Number($btn.attr('framing')) || 0;
  const color = $btn.attr('color') || '';
  const frame_id = $btn.attr('frame_id') || '';
  const itemsToRemove = ($btn.attr('item-to-remove') || '').split(',');

  const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
    .map(el => el.dataset.sectionId)
    .filter(Boolean);

  const updates = {};
  itemsToRemove.forEach(id => { updates[id] = 0; });
  const removePromise = Object.keys(updates).length
    ? $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      dataType: 'json',
      data: { updates }
    })
    : $.Deferred().resolve().promise();

  removePromise.always(function () {
    const items = [];

    if (parentId) {
      const props = {};
      if (color) props['Framing'] = color;
      if (frame_id) props['_frame_id'] = frame_id;
      items.push({ id: parentId, quantity: quantity, properties: props });
    }
    if (childId && parentId) {
      items.push({ id: childId, quantity: quantity, parent_id: parentId });
    }
    if (framingServiceId && parentId) {
      items.push({ id: framingServiceId, quantity: quantity, parent_id: parentId });
    }

    if (!items.length) return;

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {
        items,
        sections: sectionIds
      }
    }).then(function (response) {
      if (typeof window.manualCartRefresh === 'function') {
        window.manualCartRefresh(response);
      }
    });
  });
});
$(document).on('cart:update cart:updated', function (e) {
  if (syncing) return;
  syncing = true;

  var changedInputs = [];
  var processed = new Set(); // to skip inputs we've handled via grouping

  // 1) Loop each parent line
  $('.cart-items__table-row[data-key]').each(function () {
    var $parent = $(this);
    var parentKey = $parent.attr('data-key');
    if (!parentKey) return;

    var $parentInput = $parent.find('input[name="updates[]"]');
    if (!$parentInput.length) return;

    var pQty = parseInt($parentInput.val(), 10) || 0;

    // 2) Find all children of this parent
    var $children = $('.cart-items__table-row[data-parent-key="' + parentKey + '"]');

    if (!$children.length) return;

    // Helper: extract variant id from data-key (before the first ":")
    var getVariantId = function ($row) {
      var key = $row.attr('data-key') || '';
      var idx = key.indexOf(':');
      return idx > -1 ? key.slice(0, idx) : key; // fall back to full key if no colon
    };

    // 3) Group children by variant id
    var groups = {};
    $children.each(function () {
      var $child = $(this);
      var $childInput = $child.find('input[name="updates[]"]');
      if (!$childInput.length) return;

      var vId = getVariantId($child);
      groups[vId] = groups[vId] || { inputs: [], sum: 0 };
      groups[vId].inputs.push($childInput);
      groups[vId].sum += (parseInt($childInput.val(), 10) || 0);
    });

    // 4) For each group:
    //    - if same variant appears in multiple lines, compare the SUM to the parent
    //    - if mismatch, set first to parent qty and zero-out the rest (keeps totals correct)
    //    - if only one line for that variant, fall back to the old 1:1 behavior
    Object.keys(groups).forEach(function (vId) {
      var g = groups[vId];

      if (g.inputs.length > 1) {
        // Multi-line split for the same variant (discount, promo, etc.)
        if (g.sum !== pQty) {
          // Put the full qty on the first line and zero-out others
          g.inputs.forEach(function ($input, idx) {
            var target = (idx === 0) ? pQty : 0;
            if ((parseInt($input.val(), 10) || 0) !== target) {
              $input.val(target);
              changedInputs.push($input[0]);
            }
            processed.add($input[0]);
          });
        } else {
          // Totals already match parent; mark as processed so we don't touch them again
          g.inputs.forEach(function ($input) {
            processed.add($input[0]);
          });
        }
      } else {
        // Single child line for this variant: keep the original 1:1 sync
        var $only = g.inputs[0];
        var cQty = parseInt($only.val(), 10) || 0;
        if (cQty !== pQty) {
          $only.val(pQty);
          changedInputs.push($only[0]);
        }
        processed.add($only[0]);
      }
    });
  });
  // 5) Still handle other (non-duplicate) child rows that weren’t processed above
  $('.cart-items__table-row[data-parent-key!=""]').each(function () {
    var $child = $(this);
    var $childInput = $child.find('input[name="updates[]"]');
    if (!$childInput.length) return;
    if (processed.has($childInput[0])) return; // already handled via grouping

    var parentKey = $child.attr('data-parent-key');
    var $parent = $('.cart-items__table-row[data-key="' + parentKey + '"]');
    if (!$parent.length) return;

    var $parentInput = $parent.find('input[name="updates[]"]');
    if (!$parentInput.length) return;

    var pQty = parseInt($parentInput.val(), 10) || 0;
    var cQty = parseInt($childInput.val(), 10) || 0;

    if (pQty !== cQty) {
      $childInput.val(pQty);
      changedInputs.push($childInput[0]);
    }
  });

  // 6) Fire events for anything we changed (covers custom listeners)
  if (changedInputs.length) {
    changedInputs.forEach(function (el) {
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
      el.dispatchEvent(new Event('blur', { bubbles: true }));
    });
  }


  syncing = false;
  mrkApplyGiftAdjustments()
});
$(document).on('click', '.mrk-custom-linked a', function (e) {
  e.preventDefault();
  var url = $(this).attr('href'),
  selected_size = $('.mrk-selected-option .mrk-size-item-title').text().trim(),
  selected_frame = $('frame-variant-picker .mrk-swatches-wrapper input:checked').attr('frame-color')?.toLowerCase() || $('variant-picker .mrk-swatches-wrapper input:checked').attr('frame-color').toLowerCase(),
  url = url + '?frame=' + selected_frame + '&size=' + selected_size;
  location.href = url;
})
// Shared product-form bootstrap. Runs once on PDP page-load AND again each time
// the quick-add modal injects a product (see window.mrkInitQuickAdd) so framing
// mode, swatch slider, availability filtering and the initial frame image all
// initialise identically in both contexts. Single source of truth - the modal
// reuses the exact same code paths as the PDP, nothing is duplicated.
function mrkBootstrapProductForm() {
  RemoveUnavailableVariants();
  // Bootstrap framing-mode body class FIRST so the size-specific CSS overrides
  // (frame-variant-picker hidden, framing-service hidden, and crucially the
  // FPO main-picker frame swatches shown) apply BEFORE the slider measures
  // overflow. Otherwise those swatches are still display:none when
  // initSwatchSlider runs, the slider is skipped as "hidden", and the scroll
  // arrows never appear.
  if ($('#mrk-main-variant-data').length) {
    var bootstrap_main_variant = JSON.parse($('#mrk-main-variant-data').text() || '{}');
    var bootstrap_mode = getFramingMode(bootstrap_main_variant);
    $('body').toggleClass('mrk-fpo-active', bootstrap_mode === 'Framed print only');
    // Seed the prev-framing-mode tracker so the FIRST user-triggered
    // mrkVariantChanged has a correct previous mode.
    if (typeof window.__mrkSeedPrevFramingMode === 'function') {
      window.__mrkSeedPrevFramingMode(bootstrap_mode);
    }
  }
  initSwatchSlider();
  if ($('frame-variant-picker input').length && $('variant-picker input:checked:eq(0)').val() != $('frame-variant-picker input:checked:eq(0)').val()) {
    $('variant-picker input:checked:eq(0)')[0].dispatchEvent(new Event('change', { bubbles: true }));
  }
  if (window.show_default_black_variant) {
    $('[color="black"]').show().addClass('mrk-active-gallery-frame');
  }
}

// Entry point called by quick-add.js after the product-information section is
// injected into the quick-add modal. quick-add.js re-executes the inline data
// <script>s (window.main_product_data, the framing globals, #mrk-main-variant-data,
// etc.) BEFORE calling this, so getFramingMode/updateVariants see this product's
// data. On a collection page the modal is the only PDP context, so the
// unscoped selectors above resolve to the modal content.
window.mrkInitQuickAdd = function () {
  mrkBootstrapProductForm();
  // Unlike the PDP (which lets user interaction cascade), prime price, frame
  // image and the hidden cart inputs immediately so an add-to-bag with no
  // interaction still submits the correct variant + frame/service line items.
  if (typeof updateProductPageFrame === 'function') updateProductPageFrame();
};

$(function () {
  const frameColor = new URLSearchParams(window.location.search).get('frame');
  const selectedSize = new URLSearchParams(window.location.search).get('size');
  if (frameColor) {
    $('.mrk-swatches-wrapper [frame-color="' + frameColor + '"]').prop('checked', true).trigger('change');
    if ($('.mrk-swatches-wrapper').length) {
      document.dispatchEvent(new CustomEvent('mrkBeforeVariantChanged', {
        detail: $('.mrk-size-item-main input:checked').data('value')
      }));
    }
  }
  if (selectedSize) {
    $(`.mrk-size-item-main [data-value='${selectedSize}']`).prop('checked', true)[0].dispatchEvent(new Event('change', { bubbles: true }));
  }
  var frame = $('.mrk-frame-switcher input:checked');
  if ($(frame).length) {
    $('.mrk-frame-color').val($(frame).val()).prop('disabled', false);
  }
  initStickyAddToCart();
  // We do NOT call updateVariants() here - the legacy code paths trigger it
  // through their own cascade, and calling it eagerly causes the picker to
  // re-fetch and feel like the page is reloading.
  mrkBootstrapProductForm();
  const params = new URLSearchParams(window.location.search);
  if (params.has('open-cart') || window.location.hash == '#open-cart') {
    $('cart-drawer-component .header-actions__action').trigger('click');
  }
});